import { render, staticRenderFns } from "./GeneralTable.vue?vue&type=template&id=5b71a61a"
import script from "./GeneralTable.vue?vue&type=script&lang=js"
export * from "./GeneralTable.vue?vue&type=script&lang=js"
import style0 from "./GeneralTable.vue?vue&type=style&index=0&id=5b71a61a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports